import { cva } from 'class-variance-authority';

export type SearchSuggestVariant = 'primary' | 'dark';

const inputWrapperVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'border border-primary-light-3 bg-primary-light-4 hover:border-white-dark-4 focus-within:border-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const inputVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary placeholder:text-white-dark-3',
			dark: 'text-white placeholder:text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const listWrapperVariants = cva('', {
	variants: {
		variant: {
			primary: 'border-white-dark-2 bg-white',
			dark: 'border-none bg-primary py-2'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const clearIconVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-white-dark-3',
			dark: 'text-primary-light-3'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const searchIconVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

/** Ícone de limpar e lupa dentro do dialog - dark tem fundo preto */
const dialogInputClearIconVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-white-dark-3',
			dark: 'text-primary-light-3'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogInputSearchIconVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const groupHeadingVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const groupIconVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const groupItemWrapperVariants = cva('', {
	variants: {
		variant: {
			primary: 'data-highlighted:bg-white-dark-2',
			dark: 'data-highlighted:bg-primary-light-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const groupItemTextVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const groupItemSubTextVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary-light-1',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const emptyStateIconWrapperVariants = cva('', {
	variants: {
		variant: {
			primary: 'size-[47.5px] rounded-full bg-white-dark-2',
			dark: 'size-12 rounded-full p-[6px] bg-primary-light-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const emptyStateIconSubWrapperVariants = cva('', {
	variants: {
		variant: {
			primary: 'size-[70%] rounded-full bg-white-dark-4',
			dark: 'size-9 rounded-full bg-primary-light-3'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const emptyStateTitleVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const emptyStateDescriptionVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary font-normal',
			dark: 'text-white-dark-4 font-normal'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const emptyStateIconVariants = cva('', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const buttonInputVariants = cva(
	'z-10 flex h-11 flex-1 min-w-0 items-center rounded-md',
	{
		variants: {
			variant: {
				primary: 'bg-white text-primary',
				dark: 'bg-primary-light-4 text-white hover:bg-primary-light-4/90'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const separatorVariants = cva('h-px w-full', {
	variants: {
		variant: {
			primary: 'bg-white-dark-2',
			dark: 'bg-primary-light-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogMainWrapperVariants = cva('h-dvh w-dvw', {
	variants: {
		variant: {
			primary: 'bg-white',
			dark: 'bg-primary'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogCommandVariants = cva(
	'h-dvh w-full **:data-highlighted:bg-transparent **:data-highlighted:text-inherit',
	{
		variants: {
			variant: {
				primary:
					'bg-white [&_[data-highlighted]:hover]:bg-white-dark-2 [&_[data-highlighted]:hover]:text-primary',
				dark: 'bg-primary [&_[data-highlighted]:hover]:bg-primary-light-4 [&_[data-highlighted]:hover]:text-white [&_[cmdk-input-wrapper]]:bg-black'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const dialogInputVariants = cva(
	'h-16 text-ellipsis pl-5 focus:placeholder:opacity-100 appearance-none transform-gpu relative scroll-mt-20 scroll-mb-5 ios-safe-input',
	{
		variants: {
			variant: {
				primary: 'text-primary/40 placeholder:text-primary/40',
				dark: 'text-white placeholder:text-white-dark-4 caret-white selection:bg-white/20 selection:text-white'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const dialogBackIconVariants = cva('size-full h-6! w-6!', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogSeparatorVariants = cva('h-px w-full', {
	variants: {
		variant: {
			primary: 'bg-white-dark-2',
			dark: 'bg-primary-light-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogContentClassVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'z-[101]'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const dialogOverlayClassVariants = cva('', {
	variants: {
		variant: {
			primary: '',
			dark: 'z-[101]'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const placeholderTextVariants = cva('truncate text-left', {
	variants: {
		variant: {
			primary: 'text-black/50',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const resultTextVariants = cva('truncate text-left', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white'
		}
	},
	defaultVariants: { variant: 'primary' }
});

export function getSearchSuggestVariantStyles(variant: SearchSuggestVariant) {
	return {
		inputWrapper: inputWrapperVariants({ variant }),
		input: inputVariants({ variant }),
		listWrapper: listWrapperVariants({ variant }),
		clearIcon: clearIconVariants({ variant }),
		searchIcon: searchIconVariants({ variant }),
		groupHeading: groupHeadingVariants({ variant }),
		groupIcon: groupIconVariants({ variant }),
		groupItemWrapper: groupItemWrapperVariants({ variant }),
		groupItemText: groupItemTextVariants({ variant }),
		groupItemSubText: groupItemSubTextVariants({ variant }),
		emptyStateIconWrapper: emptyStateIconWrapperVariants({ variant }),
		emptyStateIconSubWrapper: emptyStateIconSubWrapperVariants({ variant }),
		emptyStateTitle: emptyStateTitleVariants({ variant }),
		emptyStateDescription: emptyStateDescriptionVariants({ variant }),
		emptyStateIcon: emptyStateIconVariants({ variant }),
		buttonInput: buttonInputVariants({ variant }),
		separator: separatorVariants({ variant }),
		dialogMainWrapper: dialogMainWrapperVariants({ variant }),
		dialogCommand: dialogCommandVariants({ variant }),
		dialogInput: dialogInputVariants({ variant }),
		dialogBackIcon: dialogBackIconVariants({ variant }),
		dialogSeparator: dialogSeparatorVariants({ variant }),
		dialogContentClass: dialogContentClassVariants({ variant }),
		dialogOverlayClass: dialogOverlayClassVariants({ variant }),
		dialogInputClearIcon: dialogInputClearIconVariants({ variant }),
		dialogInputSearchIcon: dialogInputSearchIconVariants({ variant }),
		placeholderText: placeholderTextVariants({ variant }),
		resultText: resultTextVariants({ variant })
	};
}

export type SearchSuggestVariantStyles = ReturnType<
	typeof getSearchSuggestVariantStyles
>;
